module.exports = __webpack_public_path__ + "img/MoonSword 3.d59e4c4a.png";